import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableFilterDateRangeComponent } from '../table-filter-date-range/table-filter-date-range.component';
import { TableFilterTextComponent } from '../table-filter-text/table-filter-text.component';
import { TableFilterSelectComponent } from '../table-filter-select/table-filter-select.component';
import { TableFilterNumberComponent } from '../table-filter-number/table-filter-number.component';
import { TableFilterMultiselectComponent } from '../table-filter-multiselect/table-filter-multiselect.component';
import { DateRange, Nillable } from '@web/utils';
import { TableFilterConfig } from '../../models/table-filter-config';
import { CollectionFilterKey } from '@web/common';
import { TableFilterChangeEvent } from '../../events/table-filter-change.event';
import { TableFilterType } from '../../enums/table-filter-type';
import { TableFilterCurrencyComponent } from '../table-filter-currency/table-filter-currency.component';

@Component({
  selector: 'app-table-filter',
  imports: [
    CommonModule,
    TableFilterTextComponent,
    TableFilterDateRangeComponent,
    TableFilterSelectComponent,
    TableFilterNumberComponent,
    TableFilterMultiselectComponent,
    TableFilterCurrencyComponent,
  ],
  templateUrl: './table-filter.component.html',
  styleUrls: ['./table-filter.component.scss'],
})
export class TableFilterComponent<Filter> {
  public filter = input.required<TableFilterConfig<Filter>>();
  public key = input.required<CollectionFilterKey<Filter>>();

  public readonly changes = output<TableFilterChangeEvent<Filter>>();

  protected readonly TableFilterType = TableFilterType;

  public handleTextFilterChanges(text: Nillable<string>): void {
    this.changes.emit(new TableFilterChangeEvent<Filter>(this.key(), text));
  }

  public handleNumberFilterChanges(number: Nillable<number>): void {
    this.changes.emit(new TableFilterChangeEvent<Filter>(this.key(), number));
  }

  public handleCurrencyFilterChanges(currency: Nillable<number>): void {
    this.changes.emit(new TableFilterChangeEvent<Filter>(this.key(), currency));
  }

  public handleDateRangeFilterChanges(range: Nillable<DateRange>): void {
    this.changes.emit(new TableFilterChangeEvent<Filter>(this.key(), range));
  }

  public handleSelectFilterChanges(selected: Nillable<string | number>): void {
    this.changes.emit(new TableFilterChangeEvent<Filter>(this.key(), selected));
  }

  public handleMultiSelectFilterChanges(
    selected: Nillable<string[] | number[]>,
  ): void {
    this.changes.emit(new TableFilterChangeEvent<Filter>(this.key(), selected));
  }
}
